import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Typography,
  TextField,
  MenuItem,
  Button,
  Grid,
  Select,
  InputLabel,
  FormControl,
  Paper,
} from "@mui/material";
import { getToken, base_url } from "../../config/config";

const UrlaubPlanner = () => {
  const [employees, setEmployees] = useState([]);
  const [holidayData, setHolidayData] = useState({
    holidayType: "Employee",
    holidayDate: "",
    employeeName: "",
    holidayName: "",
    country: "",
  });

  useEffect(() => {
    // Fetch employee data from API
    axios
      .get(`${base_url}/v1/getAllEmployees`)
      .then((response) => {
        setEmployees(response.data);
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
      });
  }, []);

  // Handle form inputs for holiday creation
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setHolidayData({
      ...holidayData,
      [name]: value,
    });
  };

  // Submit holiday form
  const handleSubmitHoliday = (e) => {
    e.preventDefault();

    const dataToSubmit = {
      holidayType: holidayData.holidayType,
      holidayDate: holidayData.holidayDate,
    };

    if (holidayData.holidayType === "Employee") {
      dataToSubmit.employeeName = holidayData.employeeName;
      dataToSubmit.employeeHolidayType = holidayData.employeeHolidayType; // This is important
    } else if (holidayData.holidayType === "National") {
      dataToSubmit.holidayName = holidayData.holidayName;
    }

    axios
      .post(`${base_url}/v1/createHoliday`, dataToSubmit)
      .then((response) => {
        alert("Holiday created successfully!");
      })
      .catch((error) => {
        console.error("Error creating holiday:", error);
      });
  };

  return (
    <Container maxWidth='md' style={{ marginTop: "50px" }}>
      <Typography variant='h3' align='center' gutterBottom>
        Urlaub Planner
      </Typography>

      {/* Holiday Creation Form */}
      <Typography variant='h5' gutterBottom>
        Create Holiday
      </Typography>
      <Paper style={{ padding: "20px" }}>
        <form onSubmit={handleSubmitHoliday}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Holiday Type</InputLabel>
                <Select
                  name='holidayType'
                  value={holidayData.holidayType}
                  onChange={handleInputChange}
                  fullWidth>
                  <MenuItem value='Employee'>Employee Holiday</MenuItem>
                  <MenuItem value='National'>National Holiday</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                name='holidayDate'
                label='Holiday Date'
                type='date'
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={holidayData.holidayDate}
                onChange={handleInputChange}
                required
              />
            </Grid>

            {/* Conditional fields for Employee Holiday */}

            {holidayData.holidayType === "Employee" && (
              <>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Select Employee</InputLabel>
                    <Select
                      name='employeeName'
                      value={holidayData.employeeName}
                      onChange={handleInputChange}
                      fullWidth
                      required>
                      <MenuItem value=''>-- Select Employee --</MenuItem>
                      {employees.map((employee) => (
                        <MenuItem key={employee._id} value={employee.name}>
                          {employee.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Employee Holiday Type</InputLabel>
                    <Select
                      name='employeeHolidayType'
                      value={holidayData.employeeHolidayType}
                      onChange={handleInputChange}
                      fullWidth
                      required>
                      <MenuItem value='urlaub'>Urlaub</MenuItem>
                      <MenuItem value='krank'>Krank</MenuItem>
                      <MenuItem value='unpaid-urlaub'>Unpaid Urlaub</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )}

            {/* Conditional fields for National Holiday */}
            {holidayData.holidayType === "National" && (
              <>
                <Grid item xs={12}>
                  <TextField
                    name='holidayName'
                    label='Holiday Name'
                    fullWidth
                    value={holidayData.holidayName}
                    onChange={handleInputChange}
                    required
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <Button
                variant='contained'
                color='primary'
                fullWidth
                type='submit'>
                Create Holiday
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default UrlaubPlanner;
